<form class="xr-auth-stack" [formGroup]="loginForm" (ngSubmit)="onSubmit()" #loginFormDir="ngForm">
  <div>
    <h1 class="xr-auth-title">{{ "login.title" | translate }}</h1>
    <p class="xr-auth-subtitle">{{ "login.subtitle" | translate }}</p>
  </div>

  <div class="xr-auth-field">
    <label class="xr-auth-label" for="email">{{ "login.email" | translate }}</label>
    <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
      <input matInput type="email" formControlName="email" id="email" autocomplete="email"
             [placeholder]="'login.email_placeholder' | translate"/>
      <mat-error *ngIf="emailFormControl?.hasError('required') && (emailFormControl?.touched || loginFormDir.submitted)">
        {{ 'login.email_required' | translate }}
      </mat-error>
      <mat-error *ngIf="emailFormControl?.hasError('email') && (emailFormControl?.touched || loginFormDir.submitted)">
        {{ 'login.invalid_email' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="xr-auth-field">
    <label class="xr-auth-label" for="password">{{ "login.password" | translate }}</label>
    <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
      <input matInput [type]="hidePassword ? 'password' : 'text'" id="password" formControlName="password"
             autocomplete="current-password"/>
      <button mat-icon-button matSuffix type="button" class="password-toggle" (click)="hidePassword = !hidePassword"
              [attr.aria-label]="(hidePassword ? 'login.show_password' : 'login.hide_password') | translate"
              [attr.aria-pressed]="!hidePassword">
        <i-tabler [name]="hidePassword ? 'eye' : 'eye-off'" class="icon-18"></i-tabler>
      </button>
      <mat-error *ngIf="passwordFormControl?.hasError('required') && (passwordFormControl?.touched || loginFormDir.submitted)">
        {{ 'login.password_required' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="xr-login-forgot">
    <a [routerLink]="['/recovery-password']" class="xr-auth-link">{{ "login.forgot_password" | translate }}</a>
  </div>

  <button type="submit" class="xr-btn xr-btn--primary xr-auth-submit" [disabled]="!loginForm.valid">
    {{ "login.submit" | translate }}
  </button>
</form>
